export default function advantages() {

    const advantagesContentBlock = $('.advantages_img-block__js');
    const imgBlock = $('.advantages_img__js');
    const textBlock = $('.advantages_img-text__js');

    if ($(window).width() > '767') {

        // функция которая срабатывает при изменении активного элемента. добавляет анимацию изчезновления\появления
        // и также туда атрибутами прокидываются данные для отображения в блоке
        const changeActiveItem = (src, text) => {
            advantagesContentBlock.animate({ opacity: 0 }, 200);
            setTimeout(() => {
                imgBlock.attr('src', src);
                textBlock.text(text);
                advantagesContentBlock.animate({ opacity: 1 }, 200);
            }, 200);
        }

        const $items = document.querySelectorAll('.advantages_list-item__js');
        if ($items && $items.length) {
            $items.forEach(function($item) {
                $item.addEventListener('click', function(e) {
                    // повторный клик
                    if (this.classList.contains('active')) {
                        return;
                    }

                    const $active = document.querySelector('.advantages_list-item__js.active');
                    if ($active) {
                        $active.classList.remove('active');
                    }

                    this.classList.add('active');

                    changeActiveItem(this.dataset.image, this.parentElement.querySelector('.advantages_mobile-text').textContent);
                });
            });
        }
    } else {
        $('.advantages_list__js').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            appendDots: $('.advantages__js'),
        });
    }
};
